import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useAlert } from "react-alert";
import loginImage from "../assets/images/dashboardLogin.gif";
import { Link } from "react-router-dom";

const LoginPage = ({ setIsLogged }) => {
  const history = useHistory();
  const [username, setUsername] = useState("b2cniro");
  const [password, setPassword] = useState("B2cniro@2025");
  // const [credentialsError, setCredentialsError] = useState('');
  // const [errorStatus, setErrorStatus] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const alert = useAlert();

  const submitHandler = (e) => {
    e.preventDefault();
    console.log("username", username);
    console.log("pass", password);
    userValidator();
  };

  const userValidator = async () => {
    setLoginLoading(true);
    let dataToSend = {
      userId: username,
      password: password,
      type: "login",
    };
    var config = {
      method: "POST",
      //url: '',
      url: "https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/loginGenerate",
      headers: {
        "Content-Type": "application/json",
      },
      data: dataToSend,
      validateStatus: function (status) {
        return status >= 200 && status <= 400;
      },
    };
    try {
      const axiosData = await axios.request(config);
      // console.log(axiosData);
      if (axiosData.status === 200) {
        if (axiosData.data.accessTo) {
          if (axiosData.data.accessTo.portal) {
            // setErrorStatus(false);
            setIsLogged(true);
            localStorage.setItem("credentials", JSON.stringify(axiosData.data));
            history.push("/");
            // window.location.reload();
            setLoginLoading(false);
          } else {
            setLoginLoading(false);
            alert.error("Login Denied. Please Contact NirogGyan Sales Team.");
          }
        } else {
          setLoginLoading(false);
          alert.error("Login Denied. Please Contact NirogGyan Sales Team.");
        }
      } else {
        setLoginLoading(false);
        alert.error(
          <span style={{ textTransform: "capitalize", fontSize: "15px" }}>
            {axiosData.data.message}
          </span>
        );
      }
    } catch (error) {
      console.log(error);
      console.log(error.message);
      alert.error(error.message);
      setLoginLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#E9F5FE",
        height: "100vh",
        padding: "18px 50px 40px",
      }}
      className="d-flex flex-column"
    >
      <nav>
        <Row className="justify-content-md-start">
          <img
            style={{ height: "50px", width: "200px" }}
            alt="logo"
            src="https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg"
          />
        </Row>
      </nav>

      <Row
        className="justify-content-md-center align-items-center mt-5"
        style={{ flexGrow: 1 }}
      >
        <Col
          lg={6}
          style={{ flexGrow: 1, alignSelf: "stretch" }}
          // className="d-flex justify-content-center align-items-center"
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "30px",
              border: "1px solid #D7D7D7",
              width: "90%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={loginImage} alt="landing-logo" width="70%" />
          </div>
        </Col>
        <Col
          xs={12}
          md={6}
          lg={4}
          className="rounded-lg"
          style={{ borderRadius: "10px", flexGrow: 1.5 }}
        >
          <h1>Login</h1>
          <Form onSubmit={submitHandler} style={{ width: "70%" }}>
            <Form.Group className="mb-3" controlId="username">
              <Form.Label style={{ color: "#000000" }}>Username</Form.Label>
              <Form.Control
                style={{ height: "40px", borderRadius: "12px" }}
                required
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId="password">
              <Form.Label style={{ color: "#000000" }}>Password</Form.Label>
              <Form.Control
                style={{ height: "40px", borderRadius: "12px" }}
                required
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <div>
                <Form.Check
                  type="checkbox"
                  label="Show Password"
                  checked={showPassword}
                  onChange={() => setShowPassword(!showPassword)}
                />
              </div>
              <div>
                <Link
                  to="/reset-password"
                  style={{ textDecoration: "underline" }}
                >
                  Forgot password?
                </Link>
              </div>
            </div>

            <Button
              style={{
                width: "100%",
                height: "40px",
                fontWeight: "400",
                fontSize: "18px",
                borderRadius: "12px",
              }}
              type="submit"
              variant="primary my-4"
              disabled={loginLoading}
            >
              {!loginLoading ? (
                "Login"
              ) : (
                <span>
                  {"Logging In"}
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginLeft: "10px" }}
                  ></span>
                </span>
              )}
            </Button>
            <div>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#6C6C6C",
                  textAlign: "center",
                }}
              >
                Don't have an account?{" "}
                <span>
                  <Link style={{ textDecoration: "underline" }} to="/signup">
                    Create account
                  </Link>
                </span>
              </p>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
